import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { CheckCircle } from "lucide-react";

const ITConsulting = () => {
  return (
    <main>

      {/* 🔥 HERO */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(5,25,55,0.85), rgba(5,25,55,0.9)), url('https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "100px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "700" }}>IT Consulting Services</h1>
          <p style={{ maxWidth: "750px", margin: "auto" }}>
            Strategic technology consulting to help businesses design scalable systems,
            adopt modern technologies, and achieve digital transformation.
          </p>
        </Container>
      </section>

      {/* 🔹 OVERVIEW */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Transforming Ideas into Technology Solutions</h2>
              <p>
                We provide end-to-end IT consulting services that bridge business
                goals with technology execution. Whether you're a startup building
                your first product or an enterprise modernizing infrastructure,
                we help you make the right technical decisions.
              </p>

              <p>
                Our consulting approach ensures scalability, performance, and
                long-term sustainability of your systems.
              </p>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg"
                alt="consulting"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔹 SERVICES GRID */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Our IT Consulting Services</h2>

          <Row className="g-4">

            {[
              {
                title: "Website & Web Systems",
                desc: "Modern web platforms, portals, and scalable applications."
              },
              {
                title: "Backend & Python Systems",
                desc: "Robust APIs, automation systems, and backend architecture."
              },
              {
                title: "Cloud Consulting",
                desc: "Azure, AWS, and scalable cloud infrastructure solutions."
              },
              {
                title: "AI & Automation",
                desc: "Intelligent automation, AI tools, and smart workflows."
              },
              {
                title: "ERP & Business Systems",
                desc: "Enterprise-grade systems for business operations."
              },
              {
                title: "System Architecture",
                desc: "Designing scalable and secure system architectures."
              }
            ].map((item, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="gov-card p-4 h-100">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 EXPERTISE SECTION (WITH BACKGROUND) */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.8)), url('https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "80px 0"
        }}
      >
        <Container>
          <Row className="align-items-center">

            <Col lg={6}>
              <h2>Our Expertise</h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Startup & MVP Consulting",
                  "Enterprise IT Strategy",
                  "Cloud Architecture Design",
                  "Full Stack System Design",
                  "AI & Automation Integration",
                  "Government & Institutional IT Solutions"
                ].map((item, index) => (
                  <li key={index} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="lightgreen" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg"
                alt="team"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔹 PROCESS */}
      <section className="gov-section">
        <Container>
          <h2 className="text-center mb-5">Our Consulting Approach</h2>

          <Row className="g-4 text-center">
            {[
              "Requirement Understanding",
              "Technology Evaluation",
              "Solution Architecture",
              "Implementation Strategy",
              "Optimization & Scaling",
              "Ongoing Support"
            ].map((step, index) => (
              <Col md={4} key={index}>
                <Card className="gov-card p-4 h-100">
                  <h5>Step {index + 1}</h5>
                  <p>{step}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* 🔥 WHY CHOOSE US */}
      <section className="gov-section gov-section-alt">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3183153/pexels-photo-3183153.jpeg"
                alt="why us"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </Col>

            <Col lg={6}>
              <h2>Why Choose IGT?</h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Real-world industry experience",
                  "Scalable and future-ready solutions",
                  "Strong technical expertise",
                  "Focus on performance & security",
                  "End-to-end consulting support"
                ].map((item, index) => (
                  <li key={index} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 CTA */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d3b66, #1d3557)",
          color: "white",
          padding: "80px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h2>Looking for IT Consulting?</h2>
          <p>Let’s build the right technology solution for your business.</p>

          <Button href="/contact" size="lg" variant="light">
            Get Consultation
          </Button>
        </Container>
      </section>

    </main>
  );
};

export default ITConsulting;